import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { usePagination } from "../../hooks/usePagination/usePagination";
import { useTranslations } from "../../providers/useTranslations";
import { getImageSource } from "../../utils/getImageSource/getImageSource";
import { ComponentHeading, MarginOptions } from "../ComponentHeading";
import { Loading } from "../Loading";
import { LoadMore } from "../LoadMore";
import { ResponsiveContainer } from "../ResponsiveContainer";
import { Typography } from "../Typography";
import { BlogItem } from "./BlogItem/BlogItem";
import style from "./BlogListing.module.scss";
export const BlogListing = ({ articles, title, isInEditor, disableTiers, errorMessage, disableLoyalty, reversed, isInAemSpa = false, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [articlesMetaData, setArticlesMetaData] = useState([]);
    const [hasError, setHasError] = useState(false);
    const [paginatedArticles, loadMoreArticles] = usePagination(articles, 6, 7);
    const { __ } = useTranslations();
    const shouldFetchLoyaltyData = !isInEditor && !disableLoyalty && !disableTiers;
    useEffect(() => {
        const fetchArticles = async () => {
            if (shouldFetchLoyaltyData) {
                setIsLoading(true);
                try {
                    const user = getUser();
                    const articlesIds = articles.map((article) => article.articleId).filter((articleId) => !!articleId);
                    const response = await LoyaltyApi.init().getArticles({
                        uuid: user.uuid,
                        ciam_token: user.ciam_token,
                        idsParams: articlesIds,
                    });
                    setArticlesMetaData(response);
                }
                catch (e) {
                    console.error(e);
                    setHasError(true);
                }
                finally {
                    setIsLoading(false);
                }
            }
        };
        fetchArticles();
    }, [shouldFetchLoyaltyData, articles]);
    if (hasError) {
        return (_jsx(Typography, { variant: "h1", className: style.error, children: errorMessage }));
    }
    const [featuredArticle, ...restArticles] = paginatedArticles;
    const featuredMetaData = disableLoyalty
        ? null
        : articlesMetaData.find((meta) => meta.article_id === featuredArticle?.articleId);
    const featuredBlogItemImage = getImageSource(featuredArticle?.image, title);
    return (_jsx(ResponsiveContainer, { size: "large", children: _jsxs("div", { className: style.container, children: [_jsxs("div", { className: classNames({ [style.aemSpaStyle]: isInAemSpa }), "data-testid": "articlesList", children: [_jsx(ComponentHeading, { testId: "articlesListHeading", margin: MarginOptions.TOP_ZERO, children: title }), isLoading ? (_jsx("div", { className: style.loading, children: _jsx(Loading, {}) })) : (_jsxs("div", { className: style.innerWrapper, children: [_jsx(BlogItem, { ...featuredArticle, image: featuredBlogItemImage, isFeatured: true, reversed: reversed, tier: disableTiers ? undefined : featuredMetaData?.levels[0], isAvailable: featuredMetaData?.is_available, points: featuredMetaData?.value, isRead: featuredMetaData?.is_read }, featuredArticle?.path), _jsx("div", { className: style.articles, "data-testid": "articleItems", children: restArticles.map((article) => {
                                        const metaData = disableLoyalty
                                            ? null
                                            : articlesMetaData.find((meta) => meta.article_id === article?.articleId);
                                        const blogItemImage = getImageSource(article?.image, title);
                                        return (_jsx(BlogItem, { ...article, image: blogItemImage, isFeatured: false, reversed: reversed, tier: disableTiers ? undefined : metaData?.levels[0], isAvailable: metaData?.is_available, points: metaData?.value, isRead: metaData?.is_read }, article?.path));
                                    }) })] }))] }), paginatedArticles < articles && _jsx(LoadMore, { label: __("load.more"), onClick: loadMoreArticles })] }) }));
};
//# sourceMappingURL=BlogListing.js.map